import { GenericLoading } from 'components/ui/Loader'
import { ReactNode } from 'react'

export interface PanelBodyProps {
  children: ReactNode
  isLoading: boolean
}

const PanelBody: React.FC<PanelBodyProps> = ({
  children,
  isLoading,
}) => {

  return (
    <div className="flex relative flex-1 overflow-y-auto flex-col justify-between">
      <div className="divide-y divide-gray-200 px-4 sm:px-6">
        <div className="space-y-6 pb-5 pt-6">{children}</div>
      </div>
      {/* <div className="p-4"> */}
      {/*   <GenericAlert message={globalErrorMessage}></GenericAlert> */}
      {/* </div> */}
      <GenericLoading loading={isLoading}></GenericLoading>
    </div>
  )
}

export default PanelBody
